// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"eK-z","carouselContainer":"fK-z"};